// extracted by mini-css-extract-plugin
export default {"index":"PageSubjectiveDetail_index__YSXhT","score":"PageSubjectiveDetail_score__PW+K0","title":"PageSubjectiveDetail_title__9im-f","spanHtml":"PageSubjectiveDetail_spanHtml__yJsCB"};